import produce from 'immer';

import {
  CREATE_LATE_FEE_FAILURE,
  EDIT_FINE_FAILURE,
  EDIT_FINE_SEQUENCE_SUCCESS,
  EDIT_FINE_SUCCESS,
  EDIT_LATE_FEE_FAILURE,
  FINE_CREATE_FAILURE,
  FINE_CREATE_SUCCESS,
  GET_FINE_FAILURE,
  GET_FINE_LIST_SUCCESS,
  GET_FINE_SUCCESS,
  GET_LATE_FEE_FAILURE,
  GET_LATE_FEE_SUCCESS,
  GET_LATE_FEES_LIST_FAILURE,
  GET_LATE_FEES_LIST_SUCCESS,
} from '@actions/fine';

const initialState: IFineStore = {
  currentFine: null,
  fines: null,
  lateFees: null,
  currentLateFee: null,
  error: null,
};

export default (state: IFineStore = initialState, action: any) =>
  produce(state, (draftState: IFineStore) => {
    switch (action.type) {
      case EDIT_FINE_SUCCESS:
      case FINE_CREATE_SUCCESS:
      case GET_FINE_SUCCESS:
        draftState.currentFine = action.response;
        draftState.error = null;

        return;

      case EDIT_FINE_FAILURE:
      case FINE_CREATE_FAILURE:
      case GET_FINE_FAILURE:
      case GET_LATE_FEES_LIST_FAILURE:
      case CREATE_LATE_FEE_FAILURE:
      case EDIT_LATE_FEE_FAILURE:
      case GET_LATE_FEE_FAILURE:
        draftState.error = action.error;

        return;

      case GET_FINE_LIST_SUCCESS:
      case EDIT_FINE_SEQUENCE_SUCCESS:
        draftState.fines = action.response;
        draftState.error = null;

        return;

      case GET_LATE_FEES_LIST_SUCCESS:
        draftState.lateFees = action.response;
        draftState.error = null;

        return;

      case GET_LATE_FEE_SUCCESS:
        draftState.currentLateFee = action.response;
        draftState.error = null;

        return;
    }
  });
